export default function(data, element, skipBinding) {
  const self = this;
  self.$el = $(element);
  self.saving = ko.observable(false);
  self.allSelected = false;


  self.bindData = function(data) {
    self.announcement = ko.mapping.fromJS(data.announcement);
    self.announcement.scheduled_for_string(self.announcement.scheduled_for());
    self.initDropzone();

    self.scheduling = ko.computed(function() {
      return (self.announcement.scheduled_for_string() && self.announcement.scheduled_for_string().trim() != '');
    });

    self.submitButtonText = ko.computed(function() {
      if(self.scheduling())
        return Kadenze.I18n.t('announcement.schedule');
      else
        return Kadenze.I18n.t('announcement.publish');

    });

    self.publishingDateText = ko.computed(function() {
      if (self.announcement.scheduled_for_string() && self.announcement.scheduled_for_string().trim() != '')
        return Kadenze.Util.getMomentDateFromObservable(self.announcement.scheduled_for_string).format(Kadenze.I18n.t('date.formats.js_default_time'));
      else
        return 'Publish Immediately';
    });

    self.emailAnnouncementText = ko.computed(function() {
      const key = self.announcement.email_class() ? 'dict.yes' : 'dict.no';
      return Kadenze.I18n.t(key).capitalize_first();
    });

    self.sendToArchivedText = ko.computed(function() {
      const key = self.announcement.send_for_archived_courses() ? 'dict.yes' : 'dict.no';
      return Kadenze.I18n.t(key).capitalize_first();
    });

    let roles = ['select_all', 'student', 'auditor', 'teaching_assistant', 'instructor', 'instructional_support', 'graduate_teaching_assistant'];
    if(Kadenze.isKadenze) {
      if (data.course_for_credit) {
        roles = roles.concat(['for_credit']);
      }
      roles = roles.concat(['certificate_track']);
    }
    if(self.announcement.course_id() == null)
      roles = roles.concat(['course_creator', 'admin', 'student_not_enrolled_in_any_courses']);
    self.availableRoles = ko.observableArray(roles);

    self.selectedRoles = ko.observableArray(self.announcement.target_roles());
    if(self.selectedRoles().length < 1)
      self.selectedRoles(['student']);

    self.selectAll = ko.computed(function() {
      const index = $.inArray('select_all', self.selectedRoles());
      if(index != -1) {
        if(!self.allSelected) {
          self.selectedRoles(self.availableRoles());
          self.allSelected = true;
        }
      } else {
        if(self.allSelected) {
          self.selectedRoles([]);
          self.allSelected = false;
        }
      }
    });

    if (self.announcement.course_id()) {
      self.adaptiveEventCategories = ko.observableArray(_.uniq(_.map(data.adaptive_events, function(event) { return event.category; })));
      self.adaptiveEvents = ko.mapping.fromJS(data.adaptive_events);
      self.selectedEvent = ko.observable();
      //Hack to make sure selected event is correctly displayed
      if (self.announcement && !_.isEmpty(self.announcement.target_event)) {
        const selected_event = _.find(_.union(self.adaptiveEvents()), function(event) {
          const te = typeof self.announcement.target_event == 'function' ? self.announcement.target_event() : self.announcement.target_event;
          return te && te.event_type() == event.event_type() && te.target_id() == event.target_id();
        });
        self.selectedEvent(selected_event);
        self.selectedEvent.notifySubscribers();
      }
      self.selectedEvent.subscribe(function() {
        self.announcement.target_event = self.selectedEvent();
        if(!_.isEmpty(self.selectedEvent())) {
          self.clearScheduledFor();
        }
      });
      self.announcement.scheduled_for_string.subscribe(function() {
        if (self.announcement.scheduled_for_string() && self.announcement.scheduled_for_string().trim() != '') {
          self.selectedEvent(null);
        }
      });
      self.sendWhenText = ko.computed(function() {
        if(self.selectedEvent && !_.isEmpty(self.selectedEvent()))
          return self.selectedEvent().category() == 'Other' ? self.selectedEvent().name() :
            (self.selectedEvent().category() + ' ' + self.selectedEvent().name());
        else
          return 'N.A';
      });
    }

    self.sendingToText = ko.computed(function() {
      if(self.selectedRoles().length < 1) {
        return 'None';
      } else {
        const output = [];
        $.each(self.selectedRoles(), function(index, role) {
          if(role != 'select_all') {
            output.push(Kadenze.I18n.n(role));
          }
        });
        return output.join(', ');
      }
    });
  };

  self.clearScheduledFor = function() {
    if (document.getElementById('scheduled_for_datepicker')) {
      document.getElementById('scheduled_for_datepicker').value = '';
    }
    self.announcement.scheduled_for_string('');
  };

  self.setTargetRoles = function() {
    const index = $.inArray('select_all', self.selectedRoles());
    if(index != -1) {
      self.selectedRoles().splice(index, 1);
      self.announcement.target_roles(self.selectedRoles());
    } else {
      self.announcement.target_roles(self.selectedRoles());
    }
  };

  self.save = function(redirectToIndex) {
    if (self.saving()) {
      return;
    }
    self.saving(true);
    let type = 'POST';
    let url = Kadenze.Routes.admin_announcements_path();

    if(self.announcement.course_id() == null) {
      if (self.announcement.id()) {
        url = Kadenze.Routes.admin_announcement_path(self.announcement.id());
        type = 'PATCH';
      }
    } else {
      url = Kadenze.Routes.course_announcements_path(self.announcement.course_id());
      if (self.announcement.id()) {
        url = Kadenze.Routes.course_announcement_path(self.announcement.course_id(), self.announcement.id());
        type = 'PATCH';
      }
    }

    self.setTargetRoles();

    const data = ko.mapping.toJS(self.announcement);
    if (data.scheduled_for_string && data.scheduled_for_string.trim().length > 0) {
      data.scheduled_for_string = Kadenze.Util.getMomentDateFromObservable(self.announcement.scheduled_for_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    } else {
      data.scheduled_for_string = null;
    }

    const request = new Kadenze.AjaxRequest({
      type: type,
      url: url,
      data: { 'announcement': data },
      dataAsJson: false
    });

    return self.requestResponse(request, redirectToIndex);
  };

  self.requestResponse = function(request, redirectToIndex) {
    request.done(function(data, textStatus, xhr) {
      data = JSON.parse(data.announcement);
      ko.mapping.fromJS(data.announcement, self.announcement);
      self.bindData(data);

      let url = Kadenze.Routes.edit_admin_announcement_path(self.announcement.id());
      if(self.announcement.course_id() != null)
        url = Kadenze.Routes.edit_course_announcement_path(self.announcement.course_id(), self.announcement.id());
      // window.location.href.replace(url);
      //exit_path: encodeURI(window.location.pathname)
      window.history.pushState({}, '', url);
      if(redirectToIndex == true) {
        url = Kadenze.Routes.admin_announcements_path();
        if(self.announcement.course_id() != null)
          url = Kadenze.Routes.course_announcements_path(self.announcement.course_id());

        Kadenze.Request.pjax({
          url: url,
          container: '#editor-container'
        });
      }
      else {
        Kadenze.Notice.success($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.message }));
      }
      self.saving(false);
    });

    request.fail(function(xhr) {
      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      self.saving(false);
    });

    return request;
  };

  self.publish = function() {
    self.announcement.scheduled_for_string(null);
    self.setTargetRoles();

    let request = null;
    let url = '';
    const data = ko.mapping.toJS(self.announcement);
    data.status = 'published';
    data.scheduled_for_string = null;

    const publish = function() {
      if(self.announcement.course_id()) {
        url = Kadenze.Routes.course_publish_announcement_path(self.announcement.id());
      } else {
        url = Kadenze.Routes.admin_publish_announcement_path(self.announcement.id());
      }

      return new Kadenze.AjaxRequest({
        type: 'PATCH',
        url: url,
        data: { 'announcement': data },
        dataAsJson: false
      });
    };

    if(self.announcement.id() === null) {
      const response = self.save(false);
      response.success(function() {
        request = publish();
        self.requestResponse(request, true);
      });
    } else {
      request = publish();
      self.requestResponse(request, true);
    }
  };

  self.schedule = function() {
    let request = null;
    let url = '';
    const data = ko.mapping.toJS(self.announcement);
    data.status = 'scheduled';
    if (data.scheduled_for_string && data.scheduled_for_string.trim().length > 0) {
      data.scheduled_for_string = Kadenze.Util.getMomentDateFromObservable(self.announcement.scheduled_for_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    }

    const schedule = function() {
      if(self.announcement.course_id()) {
        url = Kadenze.Routes.course_schedule_announcement_path(self.announcement.id());
      } else {
        url = Kadenze.Routes.admin_schedule_announcement_path(self.announcement.id());
      }

      return new Kadenze.AjaxRequest({
        type: 'PATCH',
        url: url,
        data: { 'announcement': data },
        dataAsJson: false
      });
    };

    if(self.announcement.id() === null) {
      const response = self.save(false);
      response.success(function() {
        request = schedule();
        self.requestResponse(request, true);
      });
    } else {
      request = schedule();
      self.requestResponse(request, true);
    }
  };

  self.preview = function () {
    const response = self.save(false);

    response.success(function () {
      const previewOptions = { preview: true, exit_path: encodeURI(window.location.pathname) };
      if(self.announcement.course_id() == null) {
        window.location = Kadenze.Routes.announcement_path(self.announcement.id(), previewOptions);
      } else {
        window.location = Kadenze.Routes.course_announcement_path(self.announcement.course_id(), self.announcement.id(), previewOptions);
      }
    });
  };

  self.scheduleOrPublish = function () {
    if(self.scheduling())
      self.schedule();
    else
      self.publish();
  };

  self.destroyAdminAnnouncement = function () {
    if(self.announcement.id()) {
      const requestUrl = Kadenze.Routes.admin_announcement_path(self.announcement.id());
      self.destroyAnnouncement(requestUrl);
    }
    Kadenze.Request.pjax({url: Kadenze.Routes.admin_announcements_path, container: '#main-pjax-container'});
  };

  self.destroyCourseAnnouncement = function () {
    if(self.announcement.id()) {
      const requestUrl = Kadenze.Routes.course_announcement_path(self.announcement.course_id(), self.announcement.id());
      self.destroyAnnouncement(requestUrl);
    }
    Kadenze.Request.pjax({url: Kadenze.Routes.course_announcements_path(self.announcement.course_id()), container: '#main-pjax-container'});
  };

  self.destroyAnnouncement = function (requestUrl) {
    const redirectUrl = Kadenze.Routes.course_announcements_path(self.announcement.course_id());
    Kadenze.UIUtil.makeRequest(requestUrl, 'DELETE', null, '#main-pjax-container',
      function() { //BeforeSave
        self.saving(true);
      },
      function() { //Success
        new Kadenze.Notice.success($.extend({dismissible: true}, self.defaultNoticeOptions));
        Kadenze.Request.pjax({url: redirectUrl, container: '#main-pjax-container'});
      },
      function(xhr) { //Error
        new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      },
      function() { //Complete
        self.saving(false);
        //Nothing
      });
  };

  self.initDropzone = function () {
    const $el = $('#announcement-dropzone');
    if (!$el[0].dropzone) { 
      const fileObj = { path: self.announcement.image.url() || '' };
      const acceptedFiles = '.jpg,.jpeg,.png';
      $el.addClass('dz-unit');

      const message = JST['templates/dropzone-generic']({
        title: Kadenze.I18n.t('drop_file_editor.add_image'),
        dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
        dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
        browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
        dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
        maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
        fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
        optionalLabel: Kadenze.I18n.t('drop_file_editor.optional'),
        acceptedFiles,
      });

      const uploadURL = Kadenze.Routes.temp_image_upload_path();

      const callbacks = {
        success: (file, response) => {
          self.announcement.remote_image_url = response.path;
        },
        addedfile: function(file) {},
        removedfile: function (file) {
          self.announcement.image = null;
        }
      };

      const opts = {
        acceptedFiles,
        maxFiles: 1,
        dzPreview: JST['templates/dropzone-generic-img-preview']({
          hideFileStats: true,
          containerClass: 'dz-preview--badge',
          nameLabel: Kadenze.I18n.t('file_preview.name'),
          sizeLabel: Kadenze.I18n.t('file_preview.size'),
          previewLabel: Kadenze.I18n.t('file_preview.preview'),
          removeLabel: Kadenze.I18n.t('file_preview.remove_file'),
          fileUploadProgressLabel: Kadenze.I18n.t('file_preview.file_upload_progress')
        }),
        cropOptions: {
          modalId: 'crop_modal',
          aspectRatio: 1
        }
      };

      // Initialize the Dropzone instance with options
      self.dz = new Kadenze.ImageDropZone($el, message, uploadURL, callbacks, fileObj, opts);
    }
  };

  self.removeAnnouncementImage = element => {
    console.log('constructor called for removeAnnouncementImage');
    self.announcement.image = null;
    self.save(false);
    if(self.announcement.course_id() == null) {
      window.location = Kadenze.Routes.edit_announcement_path(self.announcement.id());
    } else {
      window.location = Kadenze.Routes.edit_course_announcement_path(self.announcement.course_id(), self.announcement.id());
    }
  }

  const __construct = function() {
    console.log('constructor called for AnnouncementViewModel');
    if (!skipBinding) {
      data = JSON.parse(data);
      self.bindData(data);
    }
  }(this);

  return self;
}
